
const subpropertyAccess = {
  PUBLIC: 'public',
  PRIVATE: 'private',
}

export function subpropertyAccessColor(status){
  if (!status || status === subpropertyAccess.PUBLIC) {
    return '#67C23A'
  }

  if (!status || status === subpropertyAccess.PRIVATE) {
    return '#E6A23C'
  }
}
export function subpropertyAccessTagType(status){
  if (!status || status === subpropertyAccess.PUBLIC) {
    return 'success'
  }
  if (!status || status === subpropertyAccess.PRIVATE) {
    return 'warning'
  }
}
export default subpropertyAccess;